import type { Module } from 'vuex'
import type { RootState } from 'store'
import { state } from './state'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import type { ProjectState } from './types'

export const project: Module<ProjectState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
